import React, { useState } from 'react';

import { Row, Col, Button } from 'react-bootstrap';
import Fade from 'react-bootstrap/Fade';
import Activities_Left from './Activities_Left'

import Breadcrumb from '../../Breadcrumb/Main'
import Header from '../../headerone/Main'
import { Link } from 'react-router-dom';


function Sports() {






    const SportsImg = [

        { img: "https://files.iittp.ac.in/pics/sports/1.jpg" },
        { img: "https://files.iittp.ac.in/pics/sports/2.jpg" },
        { img: "https://files.iittp.ac.in/pics/sports/3.jpg" },
        { img: "https://files.iittp.ac.in/pics/sports/4.jpg" },
        { img: "https://files.iittp.ac.in/pics/sports/5.jpg" },
        { img: "https://files.iittp.ac.in/pics/sports/6.jpg" },
        { img: "https://files.iittp.ac.in/pics/sports/7.jpeg" },
        { img: "https://files.iittp.ac.in/pics/sports/8.jpg" },
        { img: "https://files.iittp.ac.in/pics/sports/9.jpg" },
        { img: "https://files.iittp.ac.in/pics/sports/10.jpg" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/1.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/2.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/3.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/4.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/5.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/6.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/7.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/8.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/9.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/10.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/11.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/12.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/13.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/14.png" },
        
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/16.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/17.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/21.png" },
       
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/19.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/20.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/18.png" },
        { img: "https://files.iittp.ac.in/images/demo/iit/Events/Sports/new/15.png" },
    ]







    return (

        <>
            <Header />
            <Breadcrumb title='Home' subtitle="SPORTS" />



            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">
                        <Row>
                            <div className="c-heading">
                                <h4>SPORTS</h4> <br />
                            </div>

                            <Col md={3} className='c-left custom-padding-color mb-4'>
                                <Activities_Left activeIndex={3} />
                            </Col>

                            <Col md={9} className='c-right'>
               
                        
                                <p>Indian Institute of Technology Tirupati promotes and encourages the students to participate and perform at Inter IIT Sports meet and other competition through quality training. Sports council for the students with guidance and encouragement from the faculty has created tremendous opportunities for students to hone their talents. Institution Intra-houses activities commence in the month of February every year. Students are divided into different houses and various events/games like Badminton, Table Tennis, Basketball, Volleyball, Football and Athletic events etc are conducted. Faculty and staff members are also encouraged to participate in sports events. </p>

                                <h4 className='c-headline mt-5 mb-3'>AIM AND OBJECTIVIES </h4>
                                <ul className='ms-3 c-lineheight2dot5 iarrow' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />To encourage sportsmanship and healthy competitions among the students. </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />To raise the general standard of sports and games towards achievement in Inter IIT tournament.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />To promote physical fitness and inculcate sports and health consciousness in the Institute</li>
                                </ul>

                                <h4 className='c-headline mt-5 mb-3'>ANNUAL SPORTS DAY (AWARD) FUNCTION  </h4>
                                <p>Indian Institute of Technology Tirupati honour the outstanding sports person of the Institution with special trophies for their achievement in Inter IIT, Intra IIT and other competitions. </p>

                                <h4 className='c-headline mt-5 mb-3'>Sports Committee Members</h4>
                                <p>Advisor (Faculty I/C) : <Link className='c-link' to="https://chemical.iittp.ac.in/dr-s-uday-kumar" target="_blank"> Dr. S. Udaykumar </Link></p>
                                <p>Physical Education Officer: Dr. Iyappan.I</p>
                                <p>Physical Training Instructor: Mr. Sreedhar Reddy T</p>
                                <p>Student Secretary: Pranavesh Reddy</p>
                                <p>Email : <Link className='c-link' to="mailto:sports@iittp.ac.in"> sports@iittp.ac.in</Link></p>

                                <h4 className='c-headline mt-5 mb-3'>FACILITIES </h4>
                                <p>Hitech multipurpose indoor complex for Badminton , Table Tennis, Chess , Yoga and Gym
                                    International standard Basketball court and Tennis court.
                                    Turf Pitch Cricket ground and Football ground.
                                    Standard Athletic track for track and field events.</p>


                                        <div>

                                            <h4 className='c-headline mt-5 mb-3'>Our Gallary</h4>
                                            <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                                {SportsImg.map((item, Index) => (
                                                    <div className="financial col-4 mt-3" key={Index}>
                                                        <figure className="gallery-image">
                                                            <img src={item.img} alt="img" className="img" />
                                                        </figure>
                                                    </div>
                                                ))}
                                            </div>



                                        </div>
                   

                                
                            </Col>
                        </Row>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Sports;
